// extracted by mini-css-extract-plugin
module.exports = {"Margin":"Margin--2ii4o","Select":"Select--CIh0A","Modal":"Modal--1oKKG","Alert":"Alert---Nq5x","List":"List--1_52P"};